import React from 'react';

interface AlfaProps {
    width?: number;
    height?: number;
}

export const Alfa = ({ width = 36, height = 32 }: AlfaProps) => (
    <svg
        width={width}
        height={height}
        viewBox="4 2.19116 8.0198 11.81354"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M12.0198 12.3936H4V14.0047H12.0198V12.3936Z" fill="#EF3124" />
        <path
            d="M9.46661 3.37204C9.23945 2.71228 8.97278 2.19116 8.07402 2.19116C7.17032 2.19116 6.88883 2.71228 6.6518 3.37204L4.16785 10.1991H5.81229L6.38513 8.57363H9.55056L10.0839 10.1991H11.832L9.46661 3.37204ZM6.86414 7.2063L7.99007 3.96965H8.02957L9.0913 7.2063H6.86414Z"
            fill="#EF3124"
        />
    </svg>
);
